const recentDonations = [
  { name: "Margaret T.", amount: 25, message: "Every child deserves a pencil and a dream.", time: "2 hours ago" },
  { name: "Anonymous", amount: 50, message: "For the kids in Yunnan province.", time: "5 hours ago" },
  { name: "Robert & Lisa K.", amount: 100, message: "Our kids have so much — happy to share.", time: "1 day ago" },
  { name: "David Chen", amount: 30, message: "Books open doors. Keep going!", time: "2 days ago" },
  { name: "Anonymous", amount: 20, message: "", time: "3 days ago" },
];

const giftRecords = [
  {
    student: "Xiao Ming",
    location: "Guizhou Village, China",
    gifts: ["Notebook Set", "Color Pencils"],
    photo: "https://public.readdy.ai/ai/img_res/326027e70615b87ab9d4f7dc49d093ce.jpg",
  },
  {
    student: "Amara O.",
    location: "Ogun State, Nigeria",
    gifts: ["School Bag", "Textbooks"],
    photo: "https://readdy.ai/api/search-image?query=happy%20young%20african%20girl%20with%20school%20bag%20and%20books%2C%20rural%20village%20background%2C%20bright%20sunshine%2C%20genuine%20joyful%20smile%2C%20school%20uniform%2C%20heartwarming%20scene&width=200&height=200&seq=gift2&orientation=squarish",
  },
  {
    student: "Priya S.",
    location: "Rajasthan Village, India",
    gifts: ["Winter Jacket", "Stationery Kit"],
    photo: "https://readdy.ai/api/search-image?query=happy%20young%20indian%20village%20girl%20wearing%20warm%20jacket%2C%20rural%20background%2C%20warm%20golden%20light%2C%20genuine%20smile%2C%20colorful%20traditional%20elements%2C%20heartwarming%20scene&width=200&height=200&seq=gift3&orientation=squarish",
  },
];

const villageStories = [
  {
    author: "Xiao Ming, 12",
    location: "Guizhou, China",
    excerpt: "Every morning I walk 40 minutes to school. When I received the pencils, I cried — not from sadness, but because someone far away cared about me. I want to study hard and one day help others too.",
    photo: "https://readdy.ai/api/search-image?query=scenic%20rural%20chinese%20village%20mountain%20path%20at%20sunrise%2C%20misty%20green%20hills%2C%20simple%20stone%20path%2C%20peaceful%20morning%20atmosphere%2C%20beautiful%20landscape%20photography&width=400&height=240&seq=story1&orientation=landscape",
  },
  {
    author: "Amara O., 14",
    location: "Ogun State, Nigeria",
    excerpt: "I share my village with city students so they know how lucky they are. We have no electricity at night, so I study by candlelight. But I love learning. Thank you for the school bag — it means the world.",
    photo: "https://readdy.ai/api/search-image?query=beautiful%20african%20village%20at%20golden%20hour%2C%20children%20playing%20near%20simple%20homes%2C%20warm%20orange%20sunset%2C%20lush%20green%20trees%2C%20peaceful%20rural%20community%20life&width=400&height=240&seq=story2&orientation=landscape",
  },
];

export default function DonationSection() {
  const totalDonated = 12480;
  const studentsHelped = 347;
  const giftsShipped = 892;

  return (
    <section id="donate" className="py-24 bg-gradient-to-b from-stone-50 to-white">
      <div className="max-w-7xl mx-auto px-6">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="inline-block px-4 py-1.5 rounded-full bg-rose-100 text-rose-600 text-xs font-semibold tracking-widest uppercase mb-4">
            Village &amp; City Bridge
          </span>
          <h2
            className="text-4xl md:text-5xl font-bold text-gray-900 mb-5"
            style={{ fontFamily: "'Playfair Display', serif" }}
          >
            Share a Little,<br />
            <span className="text-rose-500">Change a Life</span>
          </h2>
          <p className="text-gray-500 text-lg max-w-2xl mx-auto leading-relaxed">
            City parents donate small amounts. We buy books, pens, and clothes for village students worldwide. Every gift is tracked, every story is shared — because gratitude connects us all.
          </p>
        </div>

        {/* Stats bar */}
        <div className="grid grid-cols-3 gap-6 mb-16">
          {[
            { icon: "ri-heart-line", value: `$${totalDonated.toLocaleString()}`, label: "Total Donated", color: "text-rose-500", bg: "bg-rose-50" },
            { icon: "ri-user-smile-line", value: studentsHelped, label: "Village Students Helped", color: "text-amber-500", bg: "bg-amber-50" },
            { icon: "ri-gift-line", value: giftsShipped, label: "Gifts Shipped", color: "text-emerald-600", bg: "bg-emerald-50" },
          ].map((stat) => (
            <div key={stat.label} className={`rounded-2xl p-6 text-center ${stat.bg}`}>
              <div className={`w-10 h-10 flex items-center justify-center rounded-full mx-auto mb-3 bg-white`}>
                <i className={`${stat.icon} text-xl ${stat.color}`}></i>
              </div>
              <p className={`text-3xl font-bold ${stat.color} mb-1`}>{stat.value}</p>
              <p className="text-gray-500 text-sm">{stat.label}</p>
            </div>
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-3 gap-10 mb-16">
          {/* Recent Donations */}
          <div className="lg:col-span-1">
            <h3 className="font-bold text-gray-800 text-lg mb-5 flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-heart-fill text-rose-500"></i>
              </div>
              Recent Donations
            </h3>
            <div className="flex flex-col gap-3">
              {recentDonations.map((d, i) => (
                <div key={i} className="bg-white rounded-xl p-4 border border-gray-100 flex items-start gap-3">
                  <div className="w-9 h-9 flex-shrink-0 rounded-full bg-rose-100 flex items-center justify-center">
                    <i className="ri-user-heart-line text-rose-500 text-sm"></i>
                  </div>
                  <div className="flex-1 min-w-0">
                    <div className="flex items-center justify-between gap-2">
                      <span className="font-semibold text-gray-800 text-sm">{d.name}</span>
                      <span className="text-rose-500 font-bold text-sm flex-shrink-0">${d.amount}</span>
                    </div>
                    {d.message && (
                      <p className="text-gray-400 text-xs mt-0.5 leading-relaxed italic">&ldquo;{d.message}&rdquo;</p>
                    )}
                    <p className="text-gray-300 text-xs mt-1">{d.time}</p>
                  </div>
                </div>
              ))}
            </div>
            <a
              href="/donate"
              className="mt-5 w-full flex items-center justify-center gap-2 px-6 py-3 rounded-full bg-rose-500 text-white text-sm font-semibold hover:bg-rose-600 transition-colors cursor-pointer whitespace-nowrap"
            >
              <div className="w-4 h-4 flex items-center justify-center">
                <i className="ri-heart-line"></i>
              </div>
              Donate Now
            </a>
          </div>

          {/* Gift Tracker */}
          <div className="lg:col-span-2">
            <h3 className="font-bold text-gray-800 text-lg mb-5 flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-gift-fill text-amber-500"></i>
              </div>
              Gift Tracker — Who Received What
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-3 gap-4 mb-8">
              {giftRecords.map((g) => (
                <div key={g.student} className="bg-white rounded-2xl overflow-hidden border border-gray-100">
                  <div className="w-full h-36 overflow-hidden">
                    <img
                      src={g.photo}
                      alt={g.student}
                      className="w-full h-full object-cover object-top"
                    />
                  </div>
                  <div className="p-4">
                    <p className="font-semibold text-gray-800 text-sm">{g.student}</p>
                    <p className="text-gray-400 text-xs mb-2 flex items-center gap-1">
                      <i className="ri-map-pin-line"></i> {g.location}
                    </p>
                    <div className="flex flex-wrap gap-1">
                      {g.gifts.map((gift) => (
                        <span key={gift} className="text-xs px-2 py-0.5 rounded-full bg-amber-50 text-amber-700 font-medium">
                          🎁 {gift}
                        </span>
                      ))}
                    </div>
                  </div>
                </div>
              ))}
            </div>

            {/* Village Stories */}
            <h3 className="font-bold text-gray-800 text-lg mb-4 flex items-center gap-2">
              <div className="w-5 h-5 flex items-center justify-center">
                <i className="ri-quill-pen-line text-emerald-600"></i>
              </div>
              Village Life Stories
            </h3>
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
              {villageStories.map((s) => (
                <div key={s.author} className="bg-white rounded-2xl overflow-hidden border border-gray-100">
                  <div className="w-full h-32 overflow-hidden">
                    <img src={s.photo} alt={s.author} className="w-full h-full object-cover object-top" />
                  </div>
                  <div className="p-4">
                    <p className="font-semibold text-gray-800 text-sm">{s.author}</p>
                    <p className="text-gray-400 text-xs mb-2 flex items-center gap-1">
                      <i className="ri-map-pin-line"></i> {s.location}
                    </p>
                    <p className="text-gray-500 text-xs leading-relaxed line-clamp-3 italic">&ldquo;{s.excerpt}&rdquo;</p>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </div>

        {/* CTA Banner */}
        <div
          className="rounded-3xl overflow-hidden relative"
          style={{ background: "linear-gradient(135deg, #f43f5e 0%, #fb923c 100%)" }}
        >
          <div className="absolute inset-0 opacity-10">
            <img
              src="https://readdy.ai/api/search-image?query=children%20from%20different%20countries%20holding%20hands%20together%2C%20diverse%20group%20of%20happy%20kids%2C%20warm%20golden%20light%2C%20hopeful%20and%20joyful%20atmosphere%2C%20global%20unity%2C%20soft%20artistic%20style&width=1200&height=300&seq=donatebanner&orientation=landscape"
              alt="children together"
              className="w-full h-full object-cover object-top"
            />
          </div>
          <div className="relative z-10 px-10 py-12 flex flex-col md:flex-row items-center justify-between gap-6">
            <div>
              <h3 className="text-white text-2xl font-bold mb-2" style={{ fontFamily: "'Playfair Display', serif" }}>
                Even $5 buys a notebook that changes a child&apos;s story.
              </h3>
              <p className="text-white/80 text-sm">
                100% of donations go directly to purchasing and shipping gifts to village students. Full transparency, every gift tracked.
              </p>
            </div>
            <a
              href="/donate"
              className="flex-shrink-0 px-8 py-3 rounded-full bg-white text-rose-500 font-bold text-sm hover:bg-rose-50 transition-colors cursor-pointer whitespace-nowrap"
            >
              Start Donating Today
            </a>
          </div>
        </div>
      </div>
    </section>
  );
}
